import React from "react";

export const Dashboard = () => <div className="h-100">YOLO</div>;
